// extracted by mini-css-extract-plugin
export default {"option":"option__MnaDJ","header":"header__FkE5n"};